export class UserPermissions {
  public showCreditCheck = true;
  public showEpcCalculator = true;
  public showResiPaymentCapture = true;
  public showInvoiceDetails = false;
  public showCommunityPaymentCapture = false;
  public showEpcAssumedValues = false;
  public showUpdatePaymentMethod = true;
  public showCommercialCustomerCapture = false;
  public showCreateCustomer = false;
  public showSearchCustomers = false;
  public showCustomerDetails = false;
  public showEditCustomerAdminDetails = false;
  public showReconcileEpc = false;
  public showDocumentManagement = false;
  public manageMyIssues = false;
  public manageMyTeamsIssues = false;
  public manageAllIssues = false;
  public manageReferenceValues = false;
  public manageResiInvoice = false;
  public manageComponents = false;
  public showCommercialBilling = false;
  public showMilestoneInvoiceQueue = false;
  public showSearchProperties = false;
  public approveBatches = false;
  public approveEpcInvoices = false;
  public financeApproveBatches = false;
  public manageGeneralBanners = false;
}
